export default {
  pageTitle: 'Add Product',
  editorTitle: 'Edit Product',
  region: 'Country Site',
  selectProduct: 'Please select the category of the new product',
  selected: 'Selected',
  noCategorySelected: 'Unselected',
  selectCategory: 'Select category',
  msrpContent: 'Will be applied to each SKU of this product by default',
  vendorProductIdMsg: 'This ID be applied to each SKU of this product by default',
  onclick: 'Batch Apply',
  oneclickContent: 'To improve seller operational efficiency, we have added a Bulk Apply button. You can input market reference price, selling price, inventory, and vendor product ID, among other details. Click the button, and these details will be applied to each row in the SKU list area.',
  a: 'Accept up to ',
  b: 'product images',
  information: 'Product Information',
  productTitle: 'Product Name',
  shortDescription: 'Short Description',
  marketingPrice: 'Market Reference Price',
  copySKU: 'Will be applied to each SKU of this product by default',
  salePrice: 'Selling Price',
  pCost: 'Cost Price',
  vendorProductId: 'Vendor Product ID',
  sellerOrVendorCopySku: 'This ID be applied to each SKU of this product by default',
  brand: 'Brand',
  productPicture: 'Product Images',
  sizeChartPicture: 'Size Chart Image',
  pleaseUploadSizeChart: 'Upload size chart picture',
  productVideo: 'Product Video',
  the26s27m: '26S, 27M',
  reselect: 'Reselect',
  notRequiredOption: 'Video is limited to 30S and 30 MB',
  productType: 'Product Type',
  multiSKU: 'Multi SKU',
  singleSKU: 'Single SKU',
  defaultSpec: 'Default Variation',
  inputOther: 'Please input other',
  selectedSpec: 'Selected Variations',
  colorDifference: 'Color is typically used to describe differences in appearance.',
  sizeappearance: 'Size is typically used to describe dimensions or capacity.',
  specStyles: 'Style is typically used to describe product variations where Size and Color do not apply.',
  forClothing: 'For clothing, if the only difference is in color, please use only Color.',
  forMobile: 'For phones, if the only difference is in capacity, please use only Size. If there are differences in both capacity and color, please use Size and Color together.',
  forChose: 'For products like bed sheets with pattern differences, please use Style for these custom variations.',
  size: 'Size',
  addSize: 'Add customized size',
  selectedSize: 'Selected Or Added {spec}',
  color: 'Color',
  addColor: 'Add customized color',
  selectedColor: 'Selected Or Added Color',
  style: 'Style',
  addStyle: 'Add customized style',
  selectedStyle: 'Selected Or Added Style',
  listsSKU: 'SKU List',
  onClickSetting: 'Batch Apply',
  listPrice: 'Market Referece Price',
  salePrice1: 'Selling Price',
  stock: 'Inventory',
  alertStock: 'Warning Inventory',
  imageDefault: 'For SKUs without uploaded thumbnail images, automatically select the first image from the product carousel as the thumbnail for the current SKU',
  suggest: 'To enhance seller operational efficiency, we have added a Batch Apply feature. You can enter relevant information in this section and, by clicking Batch Apply to  apply it to all the SKUs listed below.',
  onClickApplication: 'Apply',
  traffic: 'Logistics Related Information',
  grossWeight: 'Gross Weight',
  battery: 'Battery included?',
  yes: 'Yes',
  no: 'No',
  partially: 'Partially',
  magnetic: 'Magnetic included?',
  powder: 'Powder included?',
  compressionAgent: 'Compressor included?',
  realInformation: 'Please fill in the above information truthfully. The seller will take all the responsibility and loss of the cases caused by wrongly input information of product as custom rejection or accidents',
  otherInformation: 'Other Information',
  selectStoreCateg: 'Select Store Category',
  productDetails: 'Product Description Editing',
  selectWarehouse: 'Select Warehouse',
  settingsWarehouse: 'Payment settings of the warehouse',
  onlinePay: 'Online Payment',
  COD: 'Pay On Delivery',
  prePay: 'PrePay',
  rejectPrePay: 'Reject PrePay',
  paymentMethod: 'Payment Method',
  online: 'Online Payment',
  publishOptions: 'Listing Status',
  saveAndList: 'Active',
  onlySave: 'Inactive',
  listingStatusViolationTip: 'This product is inactive due to a violation. Please apply for activation first.',
  moadlTitle: 'Please select',
  choose: 'Select',
  operation: 'Operation',
  mainPicture: 'Thumbnail',
  notApplied: 'Apply failed. You did not enter anything.',
  selectAnotherCategory: 'Select another category',
  selectThirdCategories: 'Please select one of the third categories！',
  upload5Images: 'Upload up to {0} images.',
  JPG_GIF_PNG: 'Please upload JPG GIF or PNG images.',
  fileToBig: 'The file is too large, please do not exceed 2 MB.',
  Main10Image: 'Upload up to 10 images.',
  specification: 'This variation value already exists！',
  MP4Format: 'Only support mp4 format',
  lessThan_30s: 'The video length must be less than or equal to 30 seconds.',
  noMoreThan_30M: 'No more than 30 MB',
  uploadMainPic: 'Please upload image',
  SaleThenMarketing: 'Selling price must be lower than market reference price.',
  pleaseProductTitle: 'Please enter product name！',
  selectStoreCategory: 'Please select store category!',
  packinglistempty: 'Packaging list cannot be empty',
  uploadPictures: 'Please upload images!',
  PleaseSKU: 'Please add variation',
  PleaseGrossWeight: 'Please enter gross weight！',
  pleasePaymentMethod: 'Please set payment method！',
  pleaseWarehouse: 'Please select warehouse！',
  pleaseStock: 'Please enter inventory',
  selectPicture: 'Please select image！',
  enterPCost: 'Please enter cost price!',
  pleaseSelectedSpec: 'Please Select variation！',
  confirmation: 'Confirm',
  only_10_file: 'Upload up to 10 files',
  nothing: 'No data',
  rmb: 'RMB',
  yen: 'Yen',
  pCostPrompt: 'Reference FOB Price in RMB',
  // ES023
  liquid: 'Liquid included?',

  whiteImg: 'White Background Image',
  spec: 'Specification',
  packingListTips: 'In order to avoid unnecessary after-sales, please try to fill in the product list completely.',
  packinglist: 'Packaging List',
  highSensitiveProducts: 'High Sensitive Products',
  generalProduct: 'General Product',
  phoneTabletLaptop: 'Phone/Tablet/Laptop',
  specialProduct: 'Special Product(powder,liquid,ointment)',
  electronicsGoods: 'Electronics goods(with battery,charger,with magnetism)',
  classification: 'Classification',
  requirementsWhite: 'View Requirements for white background picture',
  pleaseBrand: 'Please select brand!',
  theInfoDuplicatedNot: 'The information of this duplicated product can NOT be the same with the existing product.',
  storeFrozen: 'Store has been locked in the selected country site.',
  setActive: 'Active',
  setInactive: 'Inactive',
  nonFbk: 'Non-FBK:{0} (Avail.',
  fbk: 'FBK:{0} (Avail. {1})',
  changeNonFbkInventory: 'Change Non-FBK Inventory',
  recentlyUsed: 'Recently Used',
  inputKeyWordSearch: 'Enter keyword to search category you want',
  applyToAllVariants: 'Apply to all variants',
  applyToPartialVariants: 'Apply to partial variants',
  chooseVariationName: 'Choose variation name',
  chooseVariationValue: 'Choose variation value',
  availInventoryNonFBK: 'Avail. Inventory (Non-FBK)',
  mustBeGreaterZero: 'Must be greater than 0',
  roughWeightRadix: 'Please enter the gross weight in numerical values only, with two decimal places.',
  roughWeightRequired: 'Please enter the gross weight',
  pleaseSelectProp: 'Please select the Specification.',
  pleaseSelectShape: 'Please select the shape',
  pleaseSelectLength: 'Please fill in the length',
  pleaseSelectWidth: 'Please fill in the width',
  pleaseSelectHeight: 'Please fill in the height',
  pleaseSelectClassification: 'Please select the classification',
  invalidSpecVariantValue: 'Invalid Specification/Variant Value',
  pleaseEnterContent: 'Please enter content',
  customCodeNameValid: 'Custom Code Name must contain Chinese characters, special characters are not allowed, and the length cannot exceed 100 bytes.',
  productNameValid: 'Product Name(CN) must contain Chinese characters, special characters are not allowed, and its length cannot exceed 100 bytes.',
  imageTip: {
    product1: '1. This is the main images of your product page. Maximum 10 images can be uploaded. Drag and drop to adjust the order.',
    product2: '2. The image must be square. Recommend 500x500 px.',
    product3: '3. Max file size of each image:  1 MB.'
  },
  videoTip: {
    product1: '1. This video will display on your product page. Only 1 video can be uploaded',
    product2: '2. The video playback length does not exceed 30 seconds.',
    product3: '3. The video file size does not exceed 30MB.'
  },
  pleaseSelectSellingPrice: 'Please fill in Sku Selling Price.',
  pleaseSelectListPrice: 'Please fill in Sku List Price.',
  priceTypeError: 'Please enter the price in the correct format!',
  stockTypeError: 'Please enter the stock in the correct format!',
  pleaseListingDetail: 'Please input Product Details.',
  viewLiveProduct: 'View Live Product Page',
  editProduct: 'Edit Product',
  productCreateSuccess: 'Product Has Been Created Successfully',
  productEditSuccess: 'Product Has Been Edited Successfully',
  productCreateSuccessTips: 'Your product has been created successfully. You can now view and review it on the buyer-facing side to ensure everything appears perfectly.',
  productEditSuccessTips: 'Your product has been edited successfully. You can now view and review it on the buyer-facing side to ensure everything is displayed correctly.',
  valueAlreadyExists: 'Create failed: This value already exists.',
  customizeValueMaxLength: 'Customize value cannot exceed {max} characters.',
  warrantyCustomFormatInvalid: 'Unable to recognize the warranty period. Please check the format.',
  warrantyCustomNoCategory: 'Please select a product category before setting warranty.',
  warrantyCustomCategoryCheckFailed: 'Failed to verify category warranty requirements. Please try again.',
  warrantyNoReasonReturnPolicyLink: 'Platform 7-Day No-Reason Return Policy and Requirements >>',
  thereModificationApproval: 'There is a modification application pending approval.',
  theModificationReached: 'The modification application limit has been reached.'
}
